<template>
  <div class="general-modal-wrapper">
    <div class="general-modal-content-wrapper">
      <div class="general-modal-close-icon" @click="onClose">
        <b-icon icon="x-lg"></b-icon>
      </div>
      <div class="general-modal-content">
        <div class="general-modal-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralModal',
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoper>
.general-modal-wrapper {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.general-modal-wrapper .general-modal-content-wrapper {
  background-color: #fff;
  z-index: 9999;
  width: 98%;
  height: 98%;
  border-radius: 8px;
  position: relative;
}
.general-modal-wrapper .general-modal-content {
  height: 100%;
  /* overflow: hidden; */
  padding-block: 16px;
}

.general-modal-wrapper .general-modal-body {
  overflow: scroll;
  height: 100%;
}

.general-modal-wrapper .general-modal-close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 999;
  cursor: pointer;
  color: #a3a3a3;
}
.general-modal-wrapper .general-modal-close-icon:hover {
  color: black;
  opacity: 0.75;
}
</style>
